export default {
    'create-user': 'Crear usuario',
    'edit-user': 'Editar usuario',
    active: 'Activo',
    unactive: 'Suspendido',
    allowed: 'Autorizado',
    'not-allowed': 'No autorizado',
    username: 'Nombre de usuario',
    password: 'Contraseña',
    'have-permission-to-create-a-file': 'Tiene permiso para crear un archivo',
    save: 'Guardar',
    cancel: 'Cancelar',
    'time-zone': "zona horaria",
    "default-time-zone": "Zona horaria predeterminada",
    'delete-user': 'Eliminar usuario',
    'are-you-sure-you-want-to-delete-the-user-$': '¿Estas Seguro de Eliminar Usuario {username}?',
    'change-account-state': 'Editar estado de cuenta',
    'are-you-sure-you-want-to': 'Estas seguro de',
    'deactivate': 'Suspender',
    'activate': 'Reactivar',
    'your-current-timezone': 'Tu zona horaria actual es',
    'click-for-choose': 'Haz clic para establecerla',
    'account': 'Cuenta de {username}',
    
    'files-which': 'Archivos que tienen',
    'has-access-to-it': 'Permiso para acceder',
    "edit-time-zone": "Cambiar zona horaria",
    temp: {
        'financial-file': 'Archivo financiero',
        permission: 'Validez',
    },

    ok: 'Sí',
    confirm: 'Seguir',

    'security-alert': 'Alerta de seguridad',
    'changing-your-password-required-logout-then-you-can-login': 'si cambia su contraseña, deberá cerrar la sesión y volver a iniciar sesión con la nueva contraseña.',

    headers: {
        username: 'Usuario',
        'permission-to-create-a-file': 'Permiso de crear archivo',
        'account-state': 'Estado de cuenta',
        actions: 'Acciones',
    },

    permissions: {
        viewer: 'Permiso de solo lectura',
        accountant: 'Contador',
        advancedAccountant: 'contador avanzado',
        warehouseKeeper: 'Encargado de almacén',
        warehouseManager: 'gerente de almacén',
        treasurer: 'Tesorero'
    },

    'there-is-a-user-with-the-same-name': 'Existe otro usuario con el mismo nombre',

    addPermission: 'agregar permiso',
    NoAddedPermission: 'sin permiso añadido',

    'cancel-deportation': 'Tienes la posibilidad de cancelar la migración.',

    'select-the-warehouses': 'Almacenes para almacenistas'
}